import React from 'react';
import InviteFormModal from '../InviteFormModal/InviteFormModal';

// ConversionPopup used to be an inline registration form. Under the 2026-06-04
// product direction registration is paywalled and gated by invitation, so this
// component now delegates to InviteFormModal — same trigger surface for callers
// (AuctionDetails variants, DirectAwardDetails) without touching every call site.
const ConversionPopup = ({ isOpen, onClose, onSuccess: _onSuccess }) => {
  return <InviteFormModal isOpen={isOpen} onClose={onClose} />;
};

export default ConversionPopup;
